import type {PassportRepository, PassportRepositoryParams, PassportResponse} from './types'

export function createPassportRepository(params: PassportRepositoryParams): PassportRepository {
  const {fetch} = params

  return {
    fetchAllAccounts(): Promise<PassportResponse> {
      return fetch<never, PassportResponse, PassportResponse>({
        url: '/all_accounts',
      })
    },
  }
}
